const AMAZON_HOSTNAME_REGEX =
  /^(www\.)?amazon\.(de|com|co\.uk|fr|it|es|nl|ca|com\.au|co\.jp|in|com\.br|com\.mx|se|pl|sg|com\.tr|ae|sa)$/

const AMAZON_ASIN_PATTERNS = [
  /\/dp\/([A-Z0-9]{10})/i,
  /\/gp\/product\/([A-Z0-9]{10})/i,
  /\/gp\/aw\/d\/([A-Z0-9]{10})/i,
  /\/exec\/obidos\/ASIN\/([A-Z0-9]{10})/i,
]

export function normalizeUrl(value: string): string | null {
  try {
    const url = new URL(value)
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null
    }
    return url.toString()
  } catch {
    return null
  }
}

export function cleanAmazonUrl(urlString: string): string {
  try {
    const url = new URL(urlString)
    const hostnameMatch = AMAZON_HOSTNAME_REGEX.test(url.hostname)
    console.log("[cleanAmazonUrl] hostname:", url.hostname, "| match:", hostnameMatch)

    if (!hostnameMatch) {
      console.log("[cleanAmazonUrl] not an Amazon URL, returning as-is")
      return urlString
    }

    console.log("[cleanAmazonUrl] pathname:", url.pathname)
    for (const pattern of AMAZON_ASIN_PATTERNS) {
      const match = url.pathname.match(pattern)
      if (match) {
        const result = `https://${url.hostname}/dp/${match[1]!.toUpperCase()}`
        console.log("[cleanAmazonUrl] ASIN found:", match[1], "| clean URL:", result)
        return result
      }
    }

    // No ASIN (e.g. search URL) — strip tracking params, keep only search keyword and category
    const cleanUrl = new URL(`https://${url.hostname}${url.pathname}`)
    for (const param of ["k", "node"]) {
      const value = url.searchParams.get(param)
      if (value) cleanUrl.searchParams.set(param, value)
    }
    const result = cleanUrl.toString()
    console.log("[cleanAmazonUrl] no ASIN, stripped to search URL:", result)
    return result
  } catch (e) {
    console.error("[cleanAmazonUrl] failed to parse URL:", urlString, e)
    return urlString
  }
}
